import { T, stringFormat } from 'src/shared/helpers';
import type { ColorAttribute } from './helpers';
import type { ValueReplacementConflict } from './variantMappingValuePlan';

const describeValue = (attribute: ColorAttribute) => `“${attribute.Label}: ${attribute.Value.Label}”`;

export const describeValueReplacementConflict = ({ original, target, otherOriginals }: ValueReplacementConflict) =>
    otherOriginals.length
        ? stringFormat(
              T._('{0} would use {1}, which is also matched to or already used by {2}. Choose different store values.', 'Admin'),
              describeValue(original),
              describeValue(target),
              otherOriginals.map(describeValue).join(', ')
          )
        : stringFormat(
              T._('The match from {0} to {1} conflicts with another match for the same original value. Choose one store value.', 'Admin'),
              describeValue(original),
              describeValue(target)
          );
